import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { APP_LANGUAGE } from './app/shared/enums';

const browserLang = navigator.language.toLowerCase();
const lang: APP_LANGUAGE = browserLang.startsWith('ru') || browserLang.startsWith('uk') ? APP_LANGUAGE.UK : APP_LANGUAGE.EN;

// Create Cookiebot script dynamically
const script = document.createElement('script');
script.id = 'Cookiebot';
script.src = 'https://consent.cookiebot.com/uc.js';
script.type = 'text/javascript';
script.setAttribute('data-cbid', environment.cookiebot);
script.setAttribute('data-blockingmode', 'auto');
script.setAttribute('data-culture', lang);

document.head.appendChild(script);

if (environment.production) {
  enableProdMode();
}

const bootstrapApplication = () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}

script.addEventListener('load', () => bootstrapApplication(), { once: true })
